import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// date strings look like "DD/MM/YYYY" — parse into a real Date so they
// sort chronologically (newest first) instead of alphabetically.
function parseDate(dateStr) {
  const [day, month, year] = String(dateStr).split("/");
  return new Date(parseInt(year, 10) || 0, (parseInt(month, 10) || 1) - 1, parseInt(day, 10) || 1);
}

export class Datatable extends Component {
  render() {
    const { myData, history, type } = this.props;

    const rows = [...(myData || [])].sort(
      (a, b) => parseDate(b) - parseDate(a)
    );

    return (
      <Fragment>
        <div className="ae-table-wrap">
          <table className="table ae-table kd-month-grid">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col" className="ae-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={2} className="ae-empty">
                    <EmptyState>No pending entries.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((date, i) => (
                  <tr key={i}>
                    <td>{date}</td>
                    <td className="ae-col-action">
                      <button
                        type="button"
                        className="ae-icon-btn ae-icon-btn--view"
                        onClick={() => {
                          history.push(
                            `/expense/approve-expense/${type}-${date.replaceAll("/", "-")}`
                          );
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
